import type { I18nLocale } from 'i18n/types/I18nLocale';

export const pageHeaderContainerDonateTextByLocale: Record<I18nLocale, string> =
  {
    en: 'Donate',
    pt: 'Doar',
    es: 'Haz una Donación',
  };
